var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oct-form__col",class:[{
    'oct-form__col--dense': _vm.dense
  },("oct-form__col--" + _vm.columnWidth)]},[_vm._t("default"),(_vm.removable)?_c('oct-amount-selector',{staticClass:"oct-form-col__action",attrs:{"reducible":_vm.reducible},on:{"increase":function($event){return _vm.$emit('increase')},"decrease":function($event){return _vm.$emit('decrease')}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }